import { DataProcessorField } from '@leagueplatform/masonry-api';

export const getFieldValue = (
  fields: DataProcessorField[] | undefined,
  id: string,
) => fields?.find((field) => field.id === id)?.value;
